module.exports = __webpack_public_path__ + "img/google-search-phone.3d3a2eb2.png";